<template>
    <TagComponent
        v-if="level"
        :value="levelName"
        :variant="(levelName.toLowerCase() as any)"
    />
    <span v-else>-</span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { mapRoleLevelToName } from '@/stores/helpers'
import TagComponent from '@/components/ui/tag/TagComponent.vue'

const props = defineProps<{
    level?: number | null
}>()

const levelName = computed(() => {
    if (!props.level) return ''
    return mapRoleLevelToName(props.level) ?? ''
})
</script>
